import { useState, useEffect } from 'react'
import styled from 'styled-components'
import PageContainer from '../../components/PageContainer'
import SkinPreview from '../../components/SkinPreview'
import NewTabLink from '../../components/NewTabLink'
import Link from 'next/link'
import Button from '../../components/Button'
import LoadMoreBox from '../../components/LoadMoreBox'
import { discordInviteURL } from '../../config'

const PreviewFlex = styled.div`
  display: flex;
  flex-wrap: wrap;

  @media (max-width: 700px) {
    justify-content: center;
  }
`

const Index = ({ firstPage }) => {
  const [pageNo, setPageNo] = useState(0)
  const [skins, setSkins] = useState(firstPage)
  const [fetching, setFetching] = useState(false)
  const [eof, setEof] = useState(false)

  async function loadMore() {
    if (fetching || eof) return

    setFetching(true)

    const page = await (
      await fetch(`/api/topSkins?pageNo=${pageNo + 1}`)
    ).json()
    setSkins(skins.concat(page.skins))
    setEof(page.eof)
    setPageNo(pageNo + 1)

    setFetching(false)
  }

  return (
    <PageContainer style={{ maxWidth: '100%' }}>
      <h2>Custom Skins</h2>

      <h3>Player-created content</h3>
      <p style={{ maxWidth: 800 }}>
        This page contains content created by Mastermine players. If you believe
        any of it does not abide by <NewTabLink href='/skins/rules'>the Rules</NewTabLink>,
        please <NewTabLink href='/contact'>contact me</NewTabLink>.
      </p>

      <p>
        <Link href='/skins/upload'>
          <Button>Upload your own</Button>
        </Link>
      </p>

      <h3>Trending skins</h3>
      <PreviewFlex>
        {skins.map(mD => <SkinPreview skin={mD} key={mD.id} />)}

        <LoadMoreBox loading={fetching} freshOut={eof} onClick={loadMore} />
      </PreviewFlex>

      <p>
        <Link href='/skins/upload'>
          <Button>Upload your own</Button>
        </Link>
      </p>

      <h2>How to find more</h2>

      <p style={{ maxWidth: 800 }}>
        To find more Custom Skins or promote your own, try joining the
        game's <NewTabLink href={discordInviteURL}>Discord server</NewTabLink> which
        has a dedicated section for sharing skins.
      </p>
    </PageContainer>
  )
}

export default Index
// We pre-fetch the first page of skins so the page loads with instant content.
// Later pages are AJAXed
export async function getStaticProps(context) {
  const { skins } = await import('../api/topSkins').then(tS => tS.getTopSkinsData(0))

  return { props: { firstPage: skins }, revalidate: 1 }
}
